import React, { Component } from 'react';
import SideBar from './AdminComponents/Sidebar';
import { Redirect, Route, Link, Switch } from 'react-router-dom';
import ContentArea from './AdminComponents/ContentArea';
import superagent from 'superagent';
import ReactLoading from 'react-loading';



class Admin extends Component {

  constructor(props) {
    super(props);

     this.state={
       access_token:this.props.admin_token,
       user_details:this.props.admin_details,
       loading:true,
       loaded_successfully:false,
       api_error_message:"",
       server_changes_made:""
     }
  }

  componentWillMount(){

  }

  render() {
    const _this=this;


    if(! this.props.loginStatus)
    {
      return(<Redirect to = "/admin/login"/>);
    }

      return (
        <div className = "wrapper">
          <SideBar admin_details = {_this.props.admin_details}/>
          <ContentArea      admin_details = {_this.props.admin_details}
                            base_url={_this.props.base_url}
                            loginStatus= {this.props.loginStatus}
                            renderInThousands = {this.props.renderInThousands}
                            updateAdminDetails={_this.props.updateAdminDetails}/>
        </div>

      );

    //}


  }




}

export default Admin;
